import { render, staticRenderFns } from "./GoNogoCard.vue?vue&type=template&id=52dd859c"
import script from "./GoNogoCard.vue?vue&type=script&lang=js"
export * from "./GoNogoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports